var id = 'words-animation';
var gl = null;
var canvas = null;

function setupWebGL(canvas) {
  var contextNames = ['webgl2', 'webgl', 'experimental-webgl'];
  var context = null;

  for (var i = 0; i < contextNames.length && context === null; i++) {
    console.log(i);

    // try to get context
    try {
      context = canvas.getContext(contextNames[i]);
    } catch (e) {
      console.error(e);
    }
  }

  if (!context) {
    console.error('Could not create any WebGL context.');
  }

  // extensions
  context.ext = {};
  context.ext.instances = context.getExtension("ANGLE_instanced_arrays");
  console.log(context, context.ext.instances);

  return context;
}

// create context if one does not exists already and returns it
function Context() {
  if (gl === null) {
    canvas = document.getElementById(id);
    gl = setupWebGL(canvas);
  }
}

export { Context, gl, canvas }
